import { ReactNode } from 'react';

export function Dev(props: { children: ReactNode }) {
  if (import.meta.env.DEV) {
    return <>{props.children}</>;
  }
  return null;
}
